import { type TaxRateBreakdownInfo } from "entity/tax/common/TaxRateBreakdown/TaxRateBreakdown.api.types";

export interface ILineItemPriceBreakdownInfo {
    totalPrice: number;
    totalMargin: number;
    totalMarkup?: number;
    builderCost?: number;
    subtotal?: number;
    ownerPrice?: number;
    taxRateBreakdownInfo?: TaxRateBreakdownInfo;
}

export class LineItemPriceBreakdownInfo {
    totalPrice: number;
    totalMargin: number;
    totalMarkup?: number;
    builderCost?: number;
    subtotal?: number;
    ownerPrice?: number;
    taxRateBreakdownInfo?: TaxRateBreakdownInfo;
}
